module.exports = __webpack_public_path__ + "files/ac898721a19740b555dabbfae57cbd6d.png";